import { retailerSettingsService } from '../retailer-settings/retailer-settings';
import { returnItemsService } from '../return-items-service/return-items-service';
import { orderService } from '../order-service/order-service';
import { store } from '../../store';

const productRecommendationsServiceFunction = () => {
  const retailer = retailerSettingsService.getName();
  const product = retailerSettingsService.getProduct();
  const config = retailerSettingsService.getProductRecommendationSettings() || {};
  const { language } = store.getState();
  const recommendationsUrl = `${process.env.PRODUCT_RECOMMENDATIONS_URL}/${retailer}`;
  let iframeReference;

  const getRecommendationsUrl = () => recommendationsUrl;

  const sendMessage = (context) => {
    iframeReference.postMessage(context, recommendationsUrl);
  };

  const provideSettings = () => {
    iframeReference = document.getElementById('product-recommendations-iframe').contentWindow;
    sendMessage({ type: 'translations', data: { translations: { ...language } } });
    sendMessage({
      type: 'settings',
      data: {
        ...config,
        screenWidth: window.innerWidth,
        requestUuid: window.requestUuid,
      },
    });
  };

  const provideContext = () => {
    const itemContext = [...returnItemsService.getItems()];
    const orderContext = { ...orderService.getOrder().order_info };
    sendMessage({ type: 'context', data: { itemContext, orderContext, product } });
  };

  return { getRecommendationsUrl, provideSettings, provideContext };
};

export const productRecommendationsService = productRecommendationsServiceFunction();
